import AccessReportsRouter from "@app/access-reports/AccessReportsRouter";

import AccessReportsService from "@app/access-reports/accessReportsService";

export {
  AccessReportsRouter,

  AccessReportsService,
};
